"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactSvg = require("react-svg");
var _Anchor = _interopRequireDefault(require("../../../Atoms/Anchor"));
var SignInOut = function SignInOut(_ref) {
  var signIn = _ref.signIn,
    signOut = _ref.signOut,
    loginState = _ref.loginState,
    signInAuthorText = _ref.signInAuthorText,
    signInOutIcon = _ref.signInOutIcon,
    signOutRequest = _ref.signOutRequest,
    signInRedirectLink = _ref.signInRedirectLink;
  var signInUrl = signIn.url,
    signInText = signIn.text;
  var signOutUrl = signOut.url,
    signOutText = signOut.text;
  var signInOutLink = loginState ? signOutUrl : signInUrl;
  var onSignIn = function onSignIn(e) {
    e.preventDefault();
    window.sessionStorage.setItem(signInRedirectLink, window.location.href);
    window.location.href = signInUrl;
  };
  var onSignOut = function onSignOut(e) {
    e.preventDefault();
    signOutRequest({
      signOutUrl: signOutUrl
    });
  };
  return _react.default.createElement(_react.default.Fragment, null, signOutUrl && signInUrl && _react.default.createElement(_Anchor.default, (0, _extends2.default)({
    className: "menu-nav2__sign-in-out",
    href: signInOutLink
  }, !loginState && {
    onClick: function onClick(e) {
      return onSignIn(e);
    },
    rel: 'nofollow'
  }, loginState && {
    onClick: function onClick(e) {
      return onSignOut(e);
    }
  }, {
    "data-locator": "menu-nav2-sign-in-out"
  }), _react.default.createElement(_reactSvg.ReactSVG, {
    src: signInOutIcon,
    className: "sign-in-out__icon"
  }), loginState ? signOutText : signInAuthorText || signInText));
};
var _default = SignInOut;
exports.default = _default;
module.exports = exports["default"];